<template>
  <div>
    <span class="title" v-if="businessNames.length">
      商家验证
    </span>
    <div class="name-content-scroll">
      <div class="business-check" v-if="businessNames.length" v-for="item in businessNames">
        <span :title="'您的手机号已经是' + item + '的联系人。'">您的手机号已经是{{ item }}的联系人。</span>
        <el-button plain type="single-number" @click="openShopClick(item)">立即开店</el-button>
      </div>
    </div>
    <span class="title">
      注册新公司
    </span>
    <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>
      <el-form-item prop="companyName">
<!--        @input="inputCompany"-->
        <el-input v-model.trim="form.companyName"  maxlength="36" placeholder="请填写公司全称"></el-input>
      </el-form-item>
    </el-form>
    <div class="data-bottom-btn" @click="nextStepClick">
      立即注册
    </div>
  </div>
</template>

<script>
import { getSaveContact } from '@/api/register-shop'
import { getQryBusinessByName } from '@/api/new-company'

export default {
  name: "new-company",
  props: {
    businessNames: Array,
    registerInfo: Object
  },
  data () {
    return {
      form: {
        companyName: '',
      },
      rules: {
        companyName: [
          { required: true, message: '请填写公司全称', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5\(\)\（\）]/, message: '请输入中文或括号', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    console.log(this.registerInfo, '信息')
  },
  methods: {
    // inputCompany () {
    //   this.form.companyName = this.form.companyName.replace(
    //     /[^\u4e00-\u9fa5\(\)\（\）]/g,
    //     ""
    //   );
    // },
    openShopClick (businessName) {
      console.log(this.registerInfo, 'registerInfo')
      let params = {
        contactName: this.registerInfo.contactName,
        phone: this.registerInfo.phone,
        businessName: businessName,
        isShowLoading: true,
        loadingMessage: '注册中,请稍等...'
      }
      getQryBusinessByName(params).then(res => {
        console.log(res, '校驗商家名稱')
        if (res.data.code === '0') {
          if (res.data.data.isExist === 'true') {
            let type = 'error'
            let message = `抱歉，${businessName}已经创建过店铺，不能重复开店。`
            this.$message({
              type,
              message,
              offset: document.body.clientHeight / 2 - 21
            })
          } else if (res.data.data.isExist === 'false') {
            sessionStorage.removeItem('contactId')
            sessionStorage.removeItem('businessName')
            sessionStorage.setItem('contactId', res.data.data.contactId)
            sessionStorage.setItem('businessName', businessName)
            this.$router.replace('/business-open-shop/input-business-info')
            this.$store.dispatch("businessOpenShopSetStep", 3)
          }
        }else {
          this.$message({
            type: 'error',
            message: res.data.message,
            ccuiCustom: true,
            showClose: true
          })
        }
      })
    },
    nextStepClick () {
      let submitParams = this.registerInfo
      submitParams.businessName = this.form.companyName
      submitParams.isShowLoading = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          getSaveContact(submitParams).then(res => {
            if (res.data.code === '0') {
              if (res.data.data.exist) {
                this.$message({
                  type: 'error',
                  message: res.data.message,
                  ccuiCustom: true,
                  showClose: true
                })
                return false
              }
              sessionStorage.removeItem('contactId')
              sessionStorage.removeItem('businessName')
              sessionStorage.setItem('businessName', submitParams.businessName)
              sessionStorage.setItem('contactId', res.data.data.contactId)
              this.$router.replace('/business-open-shop/input-business-info')
              this.$store.dispatch("businessOpenShopSetStep", 3)
            }else {
              this.$message({
                type: 'error',
                message: res.data.message,
                ccuiCustom: true,
                showClose: true
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  color: #4A4A4A;
  line-height: 28px;
  display: block;
  font-weight: 600;
  margin-bottom: 20px;
  font-family: PingFangSC-Semibold, PingFangSC
}
/deep/ .el-form-item {
  margin-bottom: 20px;
}
/deep/ .el-input {
  width: 500px;
  input {
    height: 40px;
    border-radius: 4px;
  }
}
.name-content-scroll {
  max-height: 100px;
  overflow-y: auto;
  padding-right: 20px;
}
.business-check {
  font-size: 13px;
  color: #4A4A4A;
  line-height: 17px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}
/deep/ .el-button {
  background: #FFFFFF;
  border-color: #FF142F;
  span {
    color: #FF142F;
  }
  &:hover, &:active {
    border-color: #FF142F !important;
    background-color: #ffedef !important;
  }
  &:focus {
    border-color: #FF142F !important;
  }
}
  .data-bottom-btn{
    width: 500px;
    height: 40px;
    background: rgba(255, 20, 47, 1);
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
    font-weight: 600;
  }
</style>
